<template>
  <div class="input-cron">
    <el-input clearable :placeholder="placeholder" style="float: left; width: 450px" size="mini" v-model="editCronValue" :disabled="disabled" >
      <a slot="append" @click="showConfigDlg" class="config-btn" :disabled="disabled">
        <i class="el-icon-date" style="margin-right: 5px;"></i>
        Cron
      </a>

    </el-input>
    <el-dialog title="配置 Cron 表达式" :append-to-body="true" :close-on-click-modal="false" :show-close="true" width="80%" top=3vh :visible.sync="dialogVisible">
      <div>
        <easy-cron v-model="editCronValue" style="width:100%" :exeStartTime="exeStartTime" :hideYear="hideYear" :remote="remote" :hideSecond="hideSecond"></easy-cron>
      </div>
      <!-- 按钮组 -->
      <div class="butn-box" style="text-align: right; padding: 20px;">
        <el-button type="primary" @click="dialogVisible=false">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import EasyCron from './cron-main.vue'

  export default {
    name: 'input-cron',
    model: {
      prop: 'cronValue',
      event: 'change'
    },
    props: {
      cronValue: {
        type: String,
        default: ''
      },
      width: {
        type: Number,
        default: 1000
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请输入Cron表达式 '
      },
      exeStartTime: {
        type: [Number, String, Object],
        default: 0
      },
      hideSecond: {
        type: Boolean,
        default: false
      },
      hideYear: {
        type: Boolean,
        default: false
      },
      remote: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        editCronValue: this.cronValue,
        // show: false
        dialogVisible: false
      }
    },
    watch: {
      cronValue(newVal, oldVal) {
        if (newVal === this.editCronValue) {
          return
        }
        this.editCronValue = newVal
      },
      editCronValue(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    },
    methods: {
      showConfigDlg() {
        if (!this.disabled) {
          this.dialogVisible = true
        }
      }
    },
    components: {
      EasyCron
    }
  }
</script>

<style scoped>
  .input-cron, .input-ui {
  display: inline-block;
  }

  .input-cron .ivu-input-wrapper {
    width: 100% !important;
  }

  .config-btn {
    cursor: pointer;
  }

  .config-btn:hover {
    color: #2D8CF0;
  }
</style>
